import BigNum from "../../math/BigNum";
import UpgradeCostCalculator from "./UpgradeCostCalculator";

export default class ClassicUpgradeCostCalculator extends UpgradeCostCalculator {
    /**
     * @param {BigNum} baseCost 
     * @param {number} costGrowthRate 
     */
    constructor(baseCost, costGrowthRate) {
        super();

        /**
         * @constant
         * @type {BigNum}
         */ 
        this.baseCost = baseCost;
        /**
         * @constant
         * @type {BigNum}
         */ 
        this.costGrowthRate = new BigNum(costGrowthRate);

        /**
         * @constant
         * @type {BigNum}
         */ 
        this.working = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */ 
        this.working2 = new BigNum(0);
        /**
         * @constant
         * @type {BigNum}
         */ 
        this.one = new BigNum(1);

        /**
         * @constant
         * @type {number}
         */ 
        this.logCostFactor = Math.log(costGrowthRate);
    }

    /**
     * @override
     * @param {number} currentPurchaseCount 
     * @param {BigNum} out The output param
     */
    getNextPurchaseCost(currentPurchaseCount, out) {
        out.copy(this.costGrowthRate).pow(currentPurchaseCount).multiply(this.baseCost);
    }

/*

    break_infinity:

  function affordGeometricSeries(resourcesAvailable, priceStart, priceRatio, currentOwned) {
    var actualStart = priceStart.mul(priceRatio.pow(currentOwned));
    return Decimal.floor(resourcesAvailable.div(actualStart).mul(priceRatio.sub(1)).add(1).log10() / priceRatio.log10());
  }

  function sumGeometricSeries(numItems, priceStart, priceRatio, currentOwned) {
    return priceStart.mul(priceRatio.pow(currentOwned)).mul(Decimal.sub(1, priceRatio.pow(numItems))).div(Decimal.sub(1, priceRatio));
  }

*/

    /**
     * @override
     * @param {BigNum} singlePurchaseCost The cost of purchasing a single building.
     * @param {number} numberToPurchase   Must be greater than 1.
     * @param {BigNum} out The output param
     * @returns {BigNum}
     */
    calculateBulkPurchaseCost(singlePurchaseCost, numberToPurchase, out) {        
        // cost(N) = cost(1) * (F^N - 1) / (F - 1)
        //return singlePurchaseCost * ((Math.pow(this.costGrowthRate, numberToPurchase) - 1) / (costGrowthRate - 1));


        //const f1 = this.costGrowthRate.pow(numberToPurchase).subtract(1);
        this.working.copy(this.costGrowthRate);
        this.working.pow(numberToPurchase).sub(this.one);

        //const f2 = this.costGrowthRate.subtract(1);
        this.working2.copy(this.costGrowthRate);
        this.working2.sub(this.one);

        //const costRatio = f1.divide(f2);
        this.working.divide(this.working2);

        out.copy(singlePurchaseCost).multiply(this.working);

        return out;

        /////////////////////////////////////////////

        // break_infinity version:

        // const f1 = this.costGrowthRate.pow(numberToPurchase).subtract(1);
        // const f2 = this.costGrowthRate.subtract(1);
        // const costRatio = f1.divide(f2);

        // return singlePurchaseCost.multiply(costRatio);
    }

    /**
     * Returns the number of upgrades that can be purchased based on how much money we have.
     * @override
     * @param {BigNum} money The total amount of money the player has.
     * @param {BigNum} singlePurchaseCost The cost of purchasing a single upgrade.
     * @return {number}
     */
    calculateMaxAffordable(money, singlePurchaseCost) {
        // Using the equation from calculateBulkPurchaseCost, solve for N:
        // cost(N) = cost(1) * (F^N - 1) / (F - 1)
        // N = log(1 + ((F - 1) * money / cost(1))) / log(F)

        // Quick check: Make sure that we can afford at least 1.
        if (singlePurchaseCost.greaterThan(money)) {
            return 0;
        }

        ///return (int) (Math.log(1 + ((this.costGrowthRate - 1) * money / singlePurchaseCost)) / this.logCostFactor);

        this.working.copy(this.costGrowthRate).sub(this.one);
        ////const a = this.costGrowthRate.subtract(1);
        //return (int) (Math.log(1 + (a * money / singlePurchaseCost)) / this.logCostFactor);

        this.working.multiply(money).divide(singlePurchaseCost);
        //const b = a.multiply(money).divide(singlePurchaseCost)
        //return (int) (Math.log(1 + b) / this.logCostFactor);

        this.working.add(this.one);
        //const c = b.add(1);
        //return (int) (Math.log(c) / this.logCostFactor);

        const d = this.working.ln(); // <-- returns a regular number
        //const d = c.ln(); // natural log
        //return (int) (d / this.logCostFactor);

        return (d / this.logCostFactor) | 0;

        //return Decimal.floor(d.divide(this.logCostFactor)); 
    }
    
}